var React = require('react');

function Play (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"fill":"none","d":"M0 0h24v24H0V0z","key":1}),React.createElement("path",{"d":"M10 8.64L15.27 12 10 15.36V8.64M8 5v14l11-7L8 5z","key":2})]);
}

Play.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Play;

Play.default = Play;
